import { Breakpoints, styled } from '@vw-marketing/us-components';

// Spacing padding variables
const themeSizeGrid002 = '8vw';

export const StyledVideoSlideWrapper = styled.div`
  display: grid;
  grid-template-areas: 'video' 'text';
  column-gap: 30px;
  justify-content: start;
  margin-bottom: 25px;

  @media (min-width: ${Breakpoints.b560}px) {
    grid-template-areas: 'video' 'text';
  }

  @media (min-width: ${Breakpoints.b560}px) and (orientation: landscape) {
    grid-template-areas: 'video' 'text';
    margin-bottom: 10px;
  }

  @media (min-width: 767px) {
    grid-template-areas: 'video text';
    margin-bottom: 0;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    column-gap: 40px;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    column-gap: 50px;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    column-gap: 70px;
  }
`;

export const StyledTextWrapper = styled.div`
  grid-area: text;
  width: 100%;
  padding: 15px ${themeSizeGrid002} 0;

  @media (min-width: ${Breakpoints.b560}px) and (orientation: landscape) {
    padding: 10px ${themeSizeGrid002};
  }

  @media (min-width: 767px) {
    padding: 18px 0;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    padding: 34px 0;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    padding: 80px 0 0;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    padding: 120px 0 0;
  }
`;

export const StyledVideoTitle = styled.div`
  height: max-content;
  * {
    font-size: 20px;
    font-weight: bold;
  }

  @media (min-width: 767px) {
    * {
      font-size: 16px;
    }
  }

  @media (min-width: ${Breakpoints.b960}px) {
    * {
      font-size: 28px;
      line-height: 32px;
    }
  }
`;

export const StyledVideoBody = styled.div`
  height: max-content;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 300px;
  margin: 10px 0 15px;
  * {
    font-size: 16px;
    line-height: 22px;
  }
  @media (min-width: 767px) {
    * {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

export const StyledLink = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: rgb(1, 25, 77);
`;

export const StyledVideoWrapper = styled.div`
  width: 100%;
  min-height: 260px;
  grid-area: video;
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b560}px) {
    width: 100%;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.b560}px) and (orientation: landscape) {
    width: 100%;
    height: max-content;
  }

  @media (min-width: 767px) {
    width: 481px;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: 875px;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    width: 1100px;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    width: 1300px;
    height: max-content;
  }

  .youtube-video-container {
    position: relative;
  }

  .youtube-video {
    grid-area: iframe;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .youtube-video-container,
  .youtube-video {
    width: 100vw;
    height: 232px;
    grid-area: iframe;

    @media (min-width: ${Breakpoints.b560}px) {
      width: 100vw;
      height: 232px;
    }

    @media (min-width: ${Breakpoints.b560}px) and (orientation: landscape) {
      width: 100vw;
      height: 380px;
    }

    @media (min-width: 767px) {
      width: 481px;
      height: 271px;
    }

    @media (min-width: ${Breakpoints.b1280}px) {
      width: 875px;
      height: 493px;
    }

    @media (min-width: ${Breakpoints.b1600}px) {
      width: 1100px;
      height: 618px;
    }

    @media (min-width: ${Breakpoints.b1920}px) {
      width: 1300px;
      height: 732px;
    }
  }
`;

export const StyledSlideNumber = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 20px;
  margin-top: 15px;

  padding: 0 ${themeSizeGrid002};

  @media (min-width: ${Breakpoints.b560}px) and (orientation: landscape) {
    height: 35px;
    margin-top: 10px;
    padding: 0 ${themeSizeGrid002};
  }

  @media (min-width: 767px) {
    padding: 0;
    margin-top: 15px;
  }
`;

export const DisclaimersWrapper = styled.span`
  .sub-text-constainer {
    margin: 0 1px;
  }
`;
